export default __webpack_public_path__ + "static/media/EDISON_DSPP-release2-v05.ac40940a.pdf";